var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 121,
    viewBox: "0 0 108 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1292 5.92563L73.8163 20.7751L45.0685 0.5L24.1227 29.0622L0.451234 21.4783L13.8802 62.5668L13.8802 63.7109C6.23197 64.0362 -3.03641e-07 70.3752 0 78.1474C-1.99335e-07 86.1278 6.43231 92.5971 14.367 92.5971L15.4056 92.5964C20.2017 108.727 35.6907 120.5 54 120.5C72.3093 120.5 87.7983 108.727 92.5944 92.5964L94.1072 92.5894C101.822 92.3378 108 85.9682 108 78.1474L107.992 77.6705C107.747 70.0766 101.677 63.9638 94.1292 63.7062V5.92563ZM20.8697 63.1903L20.8073 82.0164C20.8073 99.1716 35.2822 113.191 53.3531 113.518L54 113.524C72.155 113.524 86.8434 99.7067 87.1865 82.6277L87.191 52.028L20.8697 63.1903ZM101.064 78.1474C101.064 82.1078 98.0016 85.3487 94.1284 85.6051V70.6898L94.8916 70.7802C98.3963 71.3815 101.064 74.4511 101.064 78.1474ZM13.487 70.7253L13.8716 70.6898V85.6051C9.99841 85.3487 6.93578 82.1078 6.93578 78.1474C6.93578 74.3191 9.79763 71.1631 13.487 70.7253Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2108 106.868C49.5791 95.9194 62.4419 90.9727 71.5894 97.4925C72.9427 98.4571 73.2542 100.331 72.2853 101.678C71.3164 103.025 69.4338 103.336 68.0806 102.371C62.4606 98.3654 54.558 101.405 53.103 108.131C52.7527 109.751 51.1496 110.781 49.5225 110.432C47.8954 110.084 46.8604 108.488 47.2108 106.868Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0085 72.5888C37.488 72.4145 39.1081 72.0426 40.7617 71.4658C43.6518 70.4578 46.0692 69.0246 47.5924 67.5511C47.8439 68.2954 47.9849 69.1416 47.9849 70.0896L47.9849 73.9046C47.9849 82.656 36.0085 82.7409 36.0085 73.9046V72.5888ZM58.4614 67.9166C58.2841 68.5683 58.1867 69.2926 58.1867 70.0896V73.9046C58.1867 82.7409 70.1631 82.656 70.1631 73.9046V72.642C68.5485 72.499 66.7427 72.1103 64.895 71.4658C62.2445 70.5413 59.9916 69.2593 58.4614 67.9166Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.efbac8310f03bc52d5b34866dd28ed17.svg";
export { ForwardRef as ReactComponent };